import { render, staticRenderFns } from "./PaywallOverlay.vue?vue&type=template&id=39f52c3a&scoped=true&"
import script from "./PaywallOverlay.vue?vue&type=script&lang=ts&"
export * from "./PaywallOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallOverlay.vue?vue&type=style&index=0&id=39f52c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f52c3a",
  null
  
)

export default component.exports